module.exports = __webpack_public_path__ + "img/greece.50fd6232.png";